import _ from 'lodash'

var diagnostics = {

	exportEnabled: false,
	emailEnabled: false,

	/**
	 * set global state from the most recent diagnostics
	 * @param serverDiagnostics array of diagnostics with the following properties
	 * {
		  "status" : "error",
		  "id" : "admin.diagnostics.mailserver",
		  "messages" : [ "java.lang.NullPointerException\n\tat ...
		  "errors" : 1,
		  "warnings" : 0
		}
	 */
	readDiagnostics: function(serverDiagnostics) {
		var trackedDiagnostics = [
			{id: 'exportserver', propertyPrefix: 'export'},
			{id: 'mailserver', propertyPrefix: 'email'}
		]
		_.each(trackedDiagnostics, function(d) {
			var result = _.find(serverDiagnostics, {'id':'admin.diagnostics.' + d.id})
			var enabled = result && result.status === 'success'
			_.set(this, d.propertyPrefix + 'Enabled', enabled)
		}.bind(this))
	}
}

export default diagnostics

diagnostics.__filename__ = 'components/diagnostics.js'
